import React, { useState, useRef } from 'react';
import './Products.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTachometerAlt, faRobot, faWind, faChartLine, faKey } from '@fortawesome/free-solid-svg-icons';
import { faApple, faWindows } from '@fortawesome/free-brands-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import VideoSection2 from './VideoSection2';
import Section from './Section';
import ProductShowcase from './ProductShowcase';

import Dashboard from './longevity1.png';
import AIImage from './ain.png';
import BoxBreathingImage from './smaller_transformed_image_resized (1).png';
import ProductivityImage from './apps_resized.png';

const Products = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sectionRef = useRef(null);
  
  const scrollToSection = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToDownload = () => {
    navigate('/download');
  };
  
  const goToPricing = () => {
    navigate('/pricing');
  };

  return (
    <div className="prd-page">
      <Helmet>
        <title>WhiteMatter - Erasys</title>
        <meta
          name="description"
          content="Discover WhiteMatter's innovative products, featuring AI-powered brain tracking for enhanced focus, real-time monitoring, and personalized cognitive feedback."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="prd-hero-section tech-bg">
        <div className="prd-hero-content">
          <h1 className="prd-hero-title">WhiteMatter</h1>
          <p className="prd-hero-subtitle">
            <span className="prd-gradient-text">AI-powered</span> brain tracking for enhanced focus and productivity.
          </p>
          <div className="prd-cta-container">
            <button className="prd-btn prd-btn-learn" onClick={scrollToSection}>
              Learn More
            </button>
            <button className="prd-btn prd-btn-trial" onClick={goToPricing}>
              Try For Free
            </button>
          </div>
          <div className="prd-video-wrapper">
            <VideoSection2 />
          </div>
          <div className="prd-wellness-link-container">
            <a href="/wellness-risk-assessment" className="prd-wellness-link">
              Take the Wellness Risk Assessment
              <span className="prd-wellness-arrow">→</span>
            </a>
          </div>
        </div>
      </section>

      {/* Key Feature Section */}
      <section className="prd-feature-section">
        <div className="prd-feature-grid">
          <div className="prd-feature-item">
            <h1>24/7</h1>
            <h3>Real-Time Brain Monitoring</h3>
            <p>Continuous tracking of cognitive performance to ensure optimal mental clarity throughout the day.</p>
          </div>
          <div className="prd-feature-item">
            <h1>50%</h1>
            <h3>Increased Productivity</h3>
            <p>Our effective feedback and productivity monitoring systems are designed to streamline your tasks and invigorate efficiency.</p>
          </div>
          <div className="prd-feature-item">
            <h1>Adaptive</h1>
            <h3>Personalized Cognitive Feedback</h3>
            <p>AI learns from your habits and provides personalized tips to improve focus, reduce stress, and boost productivity.</p>
          </div>
          <div className="prd-feature-item">
            <h1>3000</h1>
            <h3>Data Points Processed</h3>
            <p>Leverage advanced AI processes over 3000 data points per hour, offering detailed reports on your mental well-being and productivity.</p>
          </div>
        </div>
      </section>

      {/* Apple-inspired Features Section */}
      <Section ref={sectionRef} />

      {/* Product Showcase Section */}
      <ProductShowcase />

      {/* Platform Section */}
      <section className="prd-platform-section">
        <div className="prd-platform-content">
          <h2>Enhance Your Performance</h2>
          <p>Discover how WhiteMatter can help you achieve new levels of productivity and mental well-being.</p>
          <div className="prd-platform-buttons">
            <div className="prd-platform-btn-container">
              <button className="prd-platform-btn prd-macos-btn" onClick={goToDownload}>
                <FontAwesomeIcon icon={faApple} size="2x" />
              </button>
              <p className="prd-platform-text">MacOS</p>
            </div>
            <div className="prd-platform-btn-container">
              <button className="prd-platform-btn prd-windows-btn" onClick={goToDownload}>
                <FontAwesomeIcon icon={faWindows} size="2x" />
              </button>
              <p className="prd-platform-text">Windows</p>
            </div>
            <div className="prd-platform-btn-container">
              <button className="prd-platform-btn prd-trial-btn" onClick={goToPricing}>
                <FontAwesomeIcon icon={faKey} size="2x" />
              </button>
              <p className="prd-platform-text">Free Trial</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;